// extracted by mini-css-extract-plugin
export default {"privacySection":"PrivacyPolicy_privacySection__Moqe0","privacyInfo":"PrivacyPolicy_privacyInfo__hklkz"};